<template>
  <div>
    <NuxtLayout name="center">
      <div class="mb-20 mt-10 text-center">
        <div
          class="item-center flex h-full w-full justify-center"
          v-if="pending"
        >
          <NuxtImg class="w-20" src="/icons/loading.svg"></NuxtImg>
        </div>
        <CommonAlert
          v-if="alert.type"
          :type="alert.type"
          :content="alert.message"
          class="mb-6"
        />
      </div>
    </NuxtLayout>
    <div class="bg-stone-white">
      <NuxtLayout name="center">
        <div class="flex justify-center py-10 md:py-16">
          <BaseButton
            class="mx-0 h-16 w-full text-lg md:w-80"
            :text="$t('error.homeBtnTitle')"
          />
        </div>
      </NuxtLayout>
    </div>
  </div>
</template>

<script setup lang="ts">
import { onMounted } from "vue";
const { t } = useI18n();

const route = useRoute();
const error = ref<Error | null>(null);
const alert = reactive<{
  message: string | null;
  type: "success" | "error" | null;
}>({
  message: null,
  type: null,
});
const pending = ref(false);

onMounted(async () => {
  const userId = route.query.userId;
  const token = route.query.token;
  const expires = route.query.expires;
  const signature = route.query.signature;

  // Basic validation check
  if (!userId || !token || !expires || !signature) {
    alert.message = t("pages.account.verify-updated-email.texts.missing_params");
    alert.type = "error";
    return;
  }

  try {
    pending.value = true;
    const response = await useAxios().get(
      `/updated-email/verify/${userId}/${token}`,
      {
        params: {
          expires,
          signature,
        },
      },
    );
    pending.value = false;

    alert.message = t("pages.account.verify-updated-email.texts.success");
    alert.type = "success";

    const localePath = useLocalePath();
    await navigateTo(
      localePath({
        path: "/account/settings",
        query: {
          email_validation_alert: 1,
        },
      }),
    );
  } catch (err: any) {
    pending.value = false;
    alert.message = t("pages.account.verify-updated-email.texts.failed");
    alert.type = "error";
  }
});
</script>
